import WhatsAppEventModal from './WhatsAppEventModal';

type RecipientGroup = 'compradores' | 'vendedores';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  recipientGroup: RecipientGroup;
  onTramiteUpdated?: () => Promise<void> | void;
};

const INITIAL_MESSAGE = `{{saludo}} {{nombre_destinatario}},\n\n--\n\nSaludos cordiales,\nEscribanía Passerini`;

const GROUP_TITLES: Record<RecipientGroup, string> = {
  vendedores: 'transferentes',
  compradores: 'adquirientes',
};

const WhatsAppQuickGroupModal = ({ open, onOpenChange, tramite, recipientGroup, onTramiteUpdated }: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      onTramiteUpdated={onTramiteUpdated}
      eventType="escrituras.mensaje_rapido_grupo"
      title={`Enviar WhatsApp rápido a ${GROUP_TITLES[recipientGroup]}`}
      description="Selecciona destinatarios, edita teléfonos, ajusta el mensaje y confirma el envío."
      recipientGroups={[recipientGroup]}
      initialMessage={INITIAL_MESSAGE}
    />
  );
};

export default WhatsAppQuickGroupModal;
